import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_contents_by_orderIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: { orderId: number }): Promise<{ result?: { Data?: { LicensePlateId?: number, LicensePlateLookupCode?: string, LotId?: number, LotLookupCode?: string, ReceiveDate?: string, LastReceiveDate?: string, VendorLotId?: number, VendorLotLookupCode?: string, ManufactureDate?: string, ExpirationDate?: string, MaterialId?: number, MaterialLookupCode?: string, MaterialName?: string, MaterialDescription?: string, PackagedAmount?: number, PackagingId?: number, PackagingName?: string, PackagingShortName?: string, NetWeight?: number, GrossWeight?: number, WeightUomId?: number, NetVolume?: number, GrossVolume?: number, VolumeUomId?: number, WeightUom?: string, VolumeUom?: string, SourceLicensePlateId?: number, SourceLicensePlateLookupCode?: string, SerialNumbers?: { Id?: number, LookupCode?: string, NetWeight?: number, GrossWeight?: number, WeightUomId?: number, NetVolume?: number, GrossVolume?: number, VolumeUomId?: number, WeightUom?: string, VolumeUom?: string }[] }[] } }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      orderId: number    }) {
        if(isNil($inParams.orderId)) {
          return true; 
        }
      return false;
    }
}
